"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("../../Checkbox"));
var DataContext_1 = require("../DataContext");
function Header(_a) {
    var children = _a.children;
    var _b = (0, DataContext_1.useDataContext)(), bulkAction = _b.bulkAction, _c = _b.selectedRowsId, selectedRowsId = _c === void 0 ? [] : _c;
    if (selectedRowsId.length > 0)
        return null;
    var className = (0, classnames_1.default)("nimbus--data-table__header");
    var handleOnChange = function () {
        bulkAction === null || bulkAction === void 0 ? void 0 : bulkAction.onSelectAll(true);
    };
    return (React.createElement("div", { className: className },
        bulkAction && (React.createElement("div", { className: "nimbus--data-table__cell-checkbox is--visible" },
            React.createElement(Checkbox_1.default, { name: "check", onChange: handleOnChange, disabled: bulkAction.disabled }))),
        children));
}
exports.default = Header;
//# sourceMappingURL=Header.js.map